import { render, staticRenderFns } from "./ViewSupplierPopUp.vue?vue&type=template&id=1f672397&scoped=true"
import script from "./ViewSupplierPopUp.vue?vue&type=script&lang=js"
export * from "./ViewSupplierPopUp.vue?vue&type=script&lang=js"
import style0 from "./ViewSupplierPopUp.vue?vue&type=style&index=0&id=1f672397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f672397",
  null
  
)

export default component.exports